import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Landmark, CreditCard, Lock, Mail, CheckCircle2 } from "lucide-react";
import { api, money, errMsg, uid } from "../lib/api";

const CheckNotice = ({ p }) => (
  <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="check-instructions">
    <p className="flex items-center gap-2 font-semibold"><CheckCircle2 className="h-4 w-4" />Pay by check selected: {money(p.amount)}</p>
    <p className="mt-1">Please write your reference <b className="font-mono" data-testid="check-reference">{p.reference}</b> on the memo line. The mailing address and who to make the check payable to are in your welcome letter email.</p>
    <p className="mt-1 text-xs">Your booking updates once our team receives and records your check.</p>
  </div>
);

export const PayChoice = ({ amount, onPay, busy, bid, onCheck }) => {
  const [o, setO] = useState({ card_fee_pct: 3, card_fee_min: 500 });
  const [check, setCheck] = useState(null);
  const [cbusy, setCbusy] = useState(false);
  useEffect(() => { api.get("/payment-options").then((r) => setO(r.data)).catch(() => {}); }, []);
  const fee = amount >= o.card_fee_min ? Math.round(amount * o.card_fee_pct) / 100 : 0;
  const byCheck = async () => {
    setCbusy(true);
    try { const { data } = await api.post(`/bookings/${bid}/pay-by-check`, { amount, idempotency_key: `chk-${bid}-${uid()}` }); setCheck(data); if (data.existing) toast.info(`You already have a check payment expected (${data.reference}).`); onCheck?.(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setCbusy(false); }
  };
  if (check) return <CheckNotice p={check} />;
  return (
    <div className="space-y-3" data-testid="pay-choice">
      {fee > 0 && <p className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-900" data-testid="bank-savings-nudge">Save <b>{money(fee)}</b> by paying from your bank account or by check. Card payments of {money(o.card_fee_min)} or more include a {o.card_fee_pct}% processing fee.</p>}
      <div className="grid gap-2 sm:grid-cols-3">
        <button className="btn-accent justify-between" disabled={busy || cbusy} onClick={() => onPay("bank")} data-testid="pay-by-bank-btn">
          <span className="flex items-center gap-2"><Landmark className="h-4 w-4" />Pay by bank</span><span>{money(amount)}</span>
        </button>
        <button className="btn-outline justify-between" disabled={busy || cbusy} onClick={() => onPay("card")} data-testid="pay-by-card-btn">
          <span className="flex items-center gap-2"><CreditCard className="h-4 w-4" />Pay by card</span><span>{money(amount + fee)}</span>
        </button>
        {bid && <button className="btn-outline justify-between" disabled={busy || cbusy} onClick={byCheck} data-testid="pay-by-check-btn">
          <span className="flex items-center gap-2"><Mail className="h-4 w-4" />{cbusy ? "Saving…" : "Pay by check"}</span><span>{money(amount)}</span>
        </button>}
      </div>
      <p className="flex items-center gap-1 text-xs text-slate-500"><Lock className="h-3 w-3" />{fee > 0 ? `Card total includes ${money(fee)} fee. Debit cards get the fee refunded automatically. ` : ""}Bank payments take up to 4 business days to clear. Check payments are confirmed once we receive the check.</p>
    </div>
  );
};
